import api from "../../Hooks/axiosApi";

interface PropertyParams {
    PageNumber: number;
    PageSize: number;
    TotalRecords: number;
    Area: string;
    ClientId: number;
    PropertyType: string;
    Bedrooms: string;
    Price: number;
    MaximumPrice: number;
    Suburb: string;
    SearchedLandSQM: number;
    ContractType: string;
    Title: string;
    PropertyId: number;
    Supplier: string;
    PropertyName: string;
    PropertyKenket: number;
}

export const GetAllpropertiesKenket = (params: PropertyParams) => {
    const response = api.get(`/api/Property/GetAllpropertiesbyparmskenket`, {
        params: params
    });
    console.log('test parms',params);

    return response;
};

export const GetAllproperties = (params: PropertyParams) => {
    const response = api.get(`/api/Property/GetAllpropertiesbyparms`, {
        params: params
    });
    console.log('test parms',params);

    return response;
};

export const getAllStates = () => {
    const response = api.get(`/api/Property/getpropertyalldll?searchId=0&searchType=state`)
    return response;
};

export const getAllAreas = (params: any) => {
    const response = api.get(`/api/Property/getpropertyalldll`, {
        params: params
    });
    return response;
};

export const getAllAreasSuburb = (params: any) => {
    const response = api.get(`/api/Property/getpropertyalldllSuburb`, {
        // const response = api.get(`/api/Property/getpropertyalldll`, {

        params: params
    });
    return response;
};